const scheduleData = [
  {
    week: 1,
    date: "2025-07-15",
    matchups: [
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
    ],
  },
  {
    week: 2,
    date: "2025-07-22",
    matchups: [
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
    ],
  },
  {
    week: 3,
    date: "2025-08-22",
    matchups: [
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
      { team1: "Placeholder Team", team2: "Placeholder Team" },
    ],
  },
  // Add more weeks...
];

export default scheduleData;
